import React from 'react';
import { getInitials, getAvatarColor } from '../utils/avatar';

export default function UserAvatar({ src, name, size = 40, fontSize = '0.9rem', className = '' }) {
  if (src) {
    return (
      <img
        src={src}
        alt={name || 'User'}
        style={{ width: size, height: size }}
        className={`avatar-img ${className}`}
        onError={(e) => {
          e.target.style.display = 'none';
        }}
      />
    );
  }
  return (
    <div
      className={`avatar-initials ${className}`}
      style={{ width: size, height: size, fontSize, backgroundColor: getAvatarColor(name) }}
    >
      {getInitials(name)}
    </div>
  );
}
